module.exports = __webpack_public_path__ + "media/images/customize-e83bf132.png";